import React, { useEffect, useState } from "react";
import {
  Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Input, Spinner,
} from "reactstrap";
import Select from "react-select";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames, VIEW_TYPE_OPTIONS } from "components/Common/ApiManagement/apiServices";
import { showToaster } from "components/Common/common";

const ReportEditModal = ({ isOpen, toggle, reportName, onSaved }) => {
  const [formLoading, setFormLoading] = useState(false);
  const [areaName, setAreaName] = useState([]);
  const [scanName, setScanName] = useState([]);
  const [scanGroup, setScanGroup] = useState([]);
  const [category, setCategory] = useState([]);
  const [scanSubcat, setScanSubcat] = useState([]);
  const [selectedViewTypes, setSelectedViewTypes] = useState([]);
  const [optionsData, setOptionsData] = useState({ 
    area: [], 
    scanGroup: [], 
    scanName: [],
    category: [], 
    scanSubcat: [] 
  });
  const [assignTo, setAssignTo] = useState("everyone");
  console.log(assignTo,"assignToassignTo")
  const [assignedOrganizations, setAssignedOrganizations] = useState([]);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
  if (reportName && isOpen) {
    setAreaName([]);
    setScanGroup([]);
    setScanName([]);
    setCategory([]);
    setScanSubcat([]);
    setSelectedViewTypes([]);
    setAssignTo("everyone");
    setAssignedOrganizations([]);

    const initializeData = async () => {
      await fetchFilterOptions();
      await fetchReportDetails();
      

    };

    initializeData();
  }
}, [reportName, isOpen]);

  useEffect(() => {
    axiosInstance
      .get(ApiNames.LIST_ORGANIZATION)
      .then(res => {
        const options = res.data.data.map(org => ({
          label: org.branch,
          value: org._id,
        }));
        setOrganizationOptions(options);
      })
      .catch(err => console.error("Error fetching organizations:", err));
  }, []);

  const fetchFilterOptions = async () => {
    const res = await axiosInstance.post(ApiNames.CUSTOM_REPORT_LIST);
    const data = res.data?.data || {};
    setOptionsData({
      area: (data.areas || []).map(v => ({ label: v, value: v })),
      scanGroup: (data.scanGroup || []).map(v => ({ label: v, value: v })),
      scanName: (data.scanName || []).map(v => ({ label: v, value: v })),
      category: (data.category || []).map(v => ({ label: v, value: v })),
      scanSubcat: (data.scanSubcat || []).map(v => ({ label: v, value: v })),
    });
  };

  

  const fetchReportDetails = async () => {
    try {
      setFormLoading(true);
      const res = await axiosInstance.post(ApiNames.VIEW_METHOD_GET, { reportName });
      const data = res.data?.data || {};

      setAreaName((data.areaName || []).map(v => ({ label: v, value: v })));
      setScanGroup((data.scanGroup || []).map(v => ({ label: v, value: v })));
      setCategory((data.category || []).map(v => ({ label: v, value: v })));
      setScanSubcat((data.scanSubcat || []).map(v => ({ label: v, value: v })));
      setScanName((data.scanName || []).map(v => ({ label: v, value: v })));
      setSelectedViewTypes(
        (data.viewTypes || [])
          .map(v => VIEW_TYPE_OPTIONS.find(opt => opt.value === v))
          .filter(Boolean)
      );
      
      // Handle assignTo with proper fallback
     
  setAssignTo(data.assignTo === "organization" ? "organization" : "everyone");



    // Handle organizations data
    const orgs = Array.isArray(data.assignedOrganizations) 
      ? data.assignedOrganizations 
      : [];
    setAssignedOrganizations(
      orgs.map(org => ({
        label: org.name || org.label || "Unknown",
        value: org.id || org.value || "",
      }))
    );
    } catch (err) {
      console.error("Failed to fetch report data:", err);
      showToaster(0, "Failed to load report details");
    } finally {
      setFormLoading(false);
      setIsInitialized(true);
    }
  };

  const handleSave = async () => {
    if (selectedViewTypes.length === 0) {
    return showToaster(0, "at least one View Type are required");
  }

  if (
    areaName.length === 0 &&
    scanName.length === 0 &&
    scanGroup.length === 0 &&
    category.length === 0 &&
    scanSubcat.length === 0
  ) {
    return showToaster(
      0,
      "Please select at least one option from Compliance Areas, Scan Name, Scan Group, Category, or Sub-Category"
    );
  }

  if (assignTo === "organization" && assignedOrganizations.length === 0) {
    return showToaster(0, "Please select at least one organization");
  }

    
    try {
      setFormLoading(true);
      
      const payload = {
        reportName,
        areaName: areaName.map(a => a.value),
        scanGroup: scanGroup.map(a => a.value),
        scanName: scanName.map(a => a.value),
        category: category.map(a => a.value),
        scanSubcat: scanSubcat.map(a => a.value),
        viewTypes: selectedViewTypes.map(v => v.value),
        assignTo,
        assignedOrganizations: assignTo === "organization" 
          ? assignedOrganizations.map(o => ({
              id: o.value,
              name: o.label,
            }))
          : [],
      };

      const res = await axiosInstance.post(ApiNames.VIEW_METHOD_UPLOAD, payload);

      if (res.data.status) {
        showToaster(1, "Report updated successfully");
        onSaved();
        toggle();
      } else {
        showToaster(0, res.data.message || "Failed to save report");
      }
    } catch (err) {
      console.error("Save failed:", err);
      showToaster(0, err.response?.data?.message || "Unexpected error occurred");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Edit Report - {reportName}</ModalHeader>
      <ModalBody>
        {!isInitialized ? (
          <div className="text-center">
            <Spinner /> Loading report data...
          </div>
        ) : (
          <>
            <FormGroup>
              <Label>Compliance Areas</Label>
              <Select 
                isMulti 
                value={areaName} 
                onChange={setAreaName} 
                options={optionsData.area} 
              />
            </FormGroup>

            <FormGroup>
              <Label>Scan Group</Label>
              <Select 
                isMulti 
                value={scanGroup} 
                onChange={setScanGroup} 
                options={optionsData.scanGroup} 
              />
            </FormGroup>

             <FormGroup>
              <Label>Scan Name</Label>
              <Select 
                isMulti 
                value={scanName} 
                onChange={setScanName} 
                options={optionsData.scanName} 
              />
            </FormGroup>

            <FormGroup>
              <Label>Category</Label>
              <Select 
                isMulti 
                value={category} 
                onChange={setCategory} 
                options={optionsData.category} 
              />
            </FormGroup>

            <FormGroup>
              <Label>Sub-Category</Label>
              <Select 
                isMulti 
                value={scanSubcat} 
                onChange={setScanSubcat} 
                options={optionsData.scanSubcat} 
              />
            </FormGroup>

            <FormGroup>
              <Label>View Types</Label>
              <Select 
                isMulti 
                value={selectedViewTypes} 
                onChange={setSelectedViewTypes} 
                options={VIEW_TYPE_OPTIONS} 
              />
            </FormGroup>
{/* <pre>{JSON.stringify(assignTo, null, 2)}</pre> */}
            <FormGroup>
              <Label>Assign To</Label>
              <div className="d-flex gap-4">
                <Label check>
                  <Input
                    type="radio"
                    name="assignTo"
                     value="everyone"
                    checked={assignTo === "everyone"}
                    onClick={(e) => {
    console.log("Radio changed to:", e.target.value);
    setAssignTo(e.target.value);
  }}
                  />{" "}
                  Everyone
                </Label>
                <Label check>
                  <Input
                    type="radio"
                    name="assignTo"
                     value="organization"
                    checked={assignTo === "organization"}
                   onClick={(e) => {
    console.log("Radio changed to:", e.target.value);
    setAssignTo(e.target.value);
  }}
                  />{" "}
                  Specific Organizations
                </Label>
              </div>
            </FormGroup>

            {assignTo === "organization" && (
              <FormGroup>
                <Label>Select Organization(s)</Label>
                <Select
                  isMulti
                  value={assignedOrganizations}
                  onChange={setAssignedOrganizations}
                  options={organizationOptions}
                  placeholder="Select organizations..."
                  isDisabled={organizationOptions.length === 0}
                />
                {organizationOptions.length === 0 && (
                  <small className="text-danger">No organizations available</small>
                )}
              </FormGroup>
            )}

            <div className="text-end mt-3">
              <Button 
                color="primary" 
                onClick={handleSave}
                disabled={formLoading}
              >
                {formLoading ? (
                  <>
                    <Spinner size="sm" /> Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ReportEditModal;